const { hideSpinner, showSpinner, stopAllSpinners } = require('./ui.spinners');

const utils = (Store = window.flex.lib.Store) => {

    function getStore() {
        return Store.get.call(Store);
    }

    function isBusy(key) {
        const store = getStore();
        if (!key) return Object.keys(store.busy.toJS()).length > 0;
        const keyParts = key.split(":");
        const hasKey = keyParts.length > 1;
        const module = hasKey ? keyParts[0] : "other";
        const moduleBusy = store.busy[module];
        return (!hasKey && moduleBusy) || (moduleBusy && moduleBusy[key]);
    }

    function onTrigger(key, handler) {
        return Store.on(key, handler);
    }

    function removeTrigger(key, handler) {
        if (!key || !handler) {
            return;
        }
        return Store.off(key, handler);
    }

    function setBusy(key, isBusy, storeRef, actionButtonCSSSelector) {
        if (!key) console.error(`Invalid Key passed to setBusy(): ${key}`);

        let activeSpinner = null;
        if (actionButtonCSSSelector && actionButtonCSSSelector != '') {
            activeSpinner = showSpinner(document.querySelector(actionButtonCSSSelector));
        }

        const store = getStore();
        const keyParts = key.split(":");
        const module = keyParts.length === 1 ? "other" : keyParts[0];
        const moduleBusy = store.busy[module];

        // Remove busy
        if (!isBusy) {

            if (!moduleBusy) return;
            if (Object.keys(moduleBusy.toJS()).length === 1 && moduleBusy[key]) store.busy.remove(module);
            else moduleBusy.remove(key);

            if (actionButtonCSSSelector && actionButtonCSSSelector != '') {
                stopAllSpinners();
            }
            return;
        }

        // Add busy
        let newKey = {};
        newKey[key] = true;
        if (!moduleBusy) {
            let newModuleKey = {};
            newModuleKey[module] = newKey;
            store.busy.set(newModuleKey).now();
        }
        else {
            if (moduleBusy[key]) return;
            moduleBusy.set(newKey).now();
        }
    }

    function setStore(data, {immediate} = {}) {
        if (data.removeBusyKey) {
            //let store = Store.get();
            //let appContext = store.appContext ? store.appContext.toJS() : {};
            //let busy = appContext.busy || {};
            //if (data.removeBusyKey in busy) delete busy[data.removeBusyKey];
            //appContext.busy = busy;
            //data.appContext = appContext;
            setBusy(data.removeBusyKey, false);
            delete data.removeBusyKey;
        }
        if(!immediate) {
            Store.get().set(data);
        } else {
            Store.get().set(data).now();
        }
        return getStore();
    }

    function trigger(...args) {
        //if(typeof params !== 'object' && typeof params !== 'undefined' )
        //    console.error(`Invalid params passed to trigger: "${key}".  Params must be an object (or null or undefined).`);
        //params = params || {};
        Store.trigger(...args);
    }

    return {
        getStore,
        isBusy,
        onTrigger,
        removeTrigger,
        setBusy,
        setStore,
        trigger
    }
};

module.exports = utils;